<template>
  <div>
    <el-table :data="messageList">
      <el-table-column prop="modeName" label="名称"> </el-table-column>
      <el-table-column
        prop="modeContent"
        label="内容"
        width="200px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            circle
            icon="el-icon-edit"
            @click="viewDetail(scope.row)"
          ></el-button>
          <el-button
            type="success"
            size="small"
            circle
            icon="el-icon-message"
            @click="sendMessage(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail
      @refresh="handleCurrentChange({ page: 1 })"
      v-model="editingMessage"
    ></detail>
    <send v-model="sendingMessage"></send>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';
import Send from '../send';

export default {
  name: 'messageTemplateList',
  data() {
    return {
      editingMessage: null,
      sendingMessage: null
    };
  },
  computed: {
    ...mapState('messageTemplate', ['totalCount', 'pagination']),
    ...mapGetters('messageTemplate', ['messageTemplateList'])
  },
  components: {
    Pagination,
    Detail,
    Send
  },
  methods: {
    viewDetail(message) {
      this.editingMessage = message;
    },
    sendMessage(message) {
      this.sendingMessage = message;
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
